var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10C7 8.89543 7.89543 8 9 8H37C38.1046 8 39 8.89543 39 10V14C39 15.1046 38.1046 16 37 16H9C7.89543 16 7 15.1046 7 14V10Z",
    fill: "#6690FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22C7 20.8954 7.89543 20 9 20H37C38.1046 20 39 20.8954 39 22V26C39 27.1046 38.1046 28 37 28H9C7.89543 28 7 27.1046 7 26V22Z",
    fill: "#6690FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 34C7 32.8954 7.89543 32 9 32H37C38.1046 32 39 32.8954 39 34V38C39 39.1046 38.1046 40 37 40H9C7.89543 40 7 39.1046 7 38V34Z",
    fill: "#6690FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 28,
    height: 4,
    fill: "#ADC8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28,
    width: 28,
    height: 4,
    fill: "#ADC8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 20.5,
    width: 25,
    height: 33,
    rx: 2.5,
    fill: "#D6E4FF",
    stroke: "#254EDB",
    strokeWidth: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 27,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#3366FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#102693"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 35,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#3366FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 43,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#3366FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 36,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#102693"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 44,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#102693"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntap);
export default __webpack_public_path__ + "static/media/ontap.b38d9785ccecb32a5251eafe80f52dbf.svg";
export { ForwardRef as ReactComponent };